import { z } from "zod";

// Schema for individual rating items (0 = not observed, 1-7 = ratings)
const ratingItemSchema = z
  .number()
  .min(0, "Rating must be at least 0")
  .max(7, "Rating cannot exceed 7");

// Schema for textarea items (Key Performance Areas)
const textareaItemSchema = z
  .string()
  .min(1, "This field is required")
  .max(2000, "Response is too long (max 2000 characters)");

// Schema for optional textarea items
const optionalTextareaItemSchema = z
  .string()
  .max(2000, "Response is too long (max 2000 characters)")
  .optional()
  .or(z.literal(""));

// Helper function to create a flattened schema based on sections
export const createPerformanceFormSchema = (sections) => {
  const schemaShape = {};

  // console.log("Creating schema for sections:", sections);

  sections.forEach((section) => {
    // console.log(
    //   "Processing section:",
    //   section.title,
    //   "with items:",
    //   section.items
    // );

    section.items.forEach((item) => {
      // console.log("Processing item:", item.key, "type:", item.type);

      if (item.type === "textarea") {
        // Add textarea fields directly to root level
        schemaShape[item.key] =
          item.required !== false
            ? textareaItemSchema
            : optionalTextareaItemSchema;
      } else {
        // Add rating fields directly to root level (default for competencies)
        schemaShape[item.key] = ratingItemSchema;
      }
    });
  });

  // console.log("Final schema shape keys:", Object.keys(schemaShape));
  return z.object(schemaShape);
};

// Validation messages for reference
export const validationMessages = {
  rating: {
    min: "Rating must be at least 0",
    max: "Rating cannot exceed 7",
    required: "Please provide a rating",
    notObserved: "0 = Not Observed",
    scale: "1-7 = Rating Scale (1 = Lowest, 7 = Highest)",
  },
  textarea: {
    required: "This field is required",
    min: "Please provide a meaningful response",
    max: "Response is too long (max 2000 characters)",
  },
};

// Helper function to validate a single field
export const validateField = (fieldPath, value, schema) => {
  try {
    // Navigate to the specific field schema
    const fieldSchema = fieldPath.split(".").reduce((current, key) => {
      return current.shape?.[key] || current;
    }, schema);

    fieldSchema.parse(value);
    return { isValid: true, error: null };
  } catch (error) {
    return {
      isValid: false,
      error: error.errors?.[0]?.message || "Invalid value",
    };
  }
};

// Helper function to get all validation errors for the form
export const getFormErrors = (formData, schema) => {
  try {
    schema.parse(formData);
    return {};
  } catch (error) {
    const errors = {};
    error.errors.forEach((err) => {
      const path = err.path.join(".");
      errors[path] = err.message;
    });
    return errors;
  }
};
